<template>
    <div class="fitbase-schedule-card" :class="{ is_over: isOver }" @click="$emit('click')">
        <div class="fitbase-schedule-card__stripe" :style="{ backgroundColor: event.color || '#3C67D6' }"></div>
        <div class="fitbase-schedule-card__body">
            <div class="fitbase-schedule-card__info">
                <!-- Время + иконки -->
                <div class="fitbase-schedule-card__top">
                    <div class="fitbase-schedule-card__time">
                        <span>{{ timeStart }}</span>
                        <template v-if="timeEnd">
                            <span class="fitbase-schedule-card__time-divider"> – </span>
                            <span>{{ timeEnd }}</span>
                        </template>
                    </div>
                    <div class="fitbase-schedule-card__icons">
                        <span v-if="event.need_register" class="fitbase-schedule-card__icon-box" title="По записи">
                            <img src="../assets/img/edit.svg" alt="">
                        </span>
                        <span v-if="event.payed === 'pay' || event.need_pay === 1" class="fitbase-schedule-card__icon-box" title="Платное">
                            <img src="../assets/img/wallet.svg" alt="">
                        </span>
                        <span v-if="event.type === 'kids'" class="fitbase-schedule-card__icon-box" title="Детское">
                            <img src="../assets/img/kid.svg" alt="">
                        </span>
                    </div>
                </div>

                <!-- Название -->
                <div class="fitbase-schedule-card__title">{{ event.name }}</div>

                <!-- Тренеры -->
                <div class="fitbase-schedule-card__trainers" v-if="trainerName || trainerReplacementName">
                    <!-- Мобайл: оригинальный тренер со зачёркиванием над строкой замены -->
                    <div
                        v-if="trainerReplacementName && trainerName"
                        class="fitbase-schedule-card__trainer fitbase-schedule-card__trainer--replaced fitbase-schedule-card__trainer--above"
                    >{{ trainerName }}</div>
                    <div class="fitbase-schedule-card__trainer-row">
                        <img v-if="trainerPhoto" :src="trainerPhoto" :alt="trainerReplacementName || trainerName" class="fitbase-schedule-card__trainer-avatar">
                        <span v-else class="fitbase-schedule-card__trainer-avatar fitbase-schedule-card__trainer-avatar--empty">
                            <img src="../assets/img/profile.svg" alt="">
                        </span>
                        <div class="fitbase-schedule-card__trainer-names">
                            <div v-if="trainerReplacementName" class="fitbase-schedule-card__trainer">{{ trainerReplacementName }}</div>
                            <div
                                v-if="trainerName"
                                class="fitbase-schedule-card__trainer fitbase-schedule-card__trainer--in-row"
                                :class="{ 'fitbase-schedule-card__trainer--replaced': !!trainerReplacementName }"
                            >{{ trainerName }}</div>
                        </div>
                        <!-- Иконки в строке тренера — только мобайл -->
                        <div class="fitbase-schedule-card__icons fitbase-schedule-card__icons--row">
                            <span v-if="event.need_register" class="fitbase-schedule-card__icon-box" title="По записи">
                                <img src="../assets/img/edit.svg" alt="">
                            </span>
                            <span v-if="event.payed === 'pay' || event.need_pay === 1" class="fitbase-schedule-card__icon-box" title="Платное">
                                <img src="../assets/img/wallet.svg" alt="">
                            </span>
                            <span v-if="event.type === 'kids'" class="fitbase-schedule-card__icon-box" title="Детское">
                                <img src="../assets/img/kid.svg" alt="">
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Бейджи -->
            <div class="fitbase-schedule-card__badges">
                <span v-if="isCancelled" class="fitbase-schedule-badge fitbase-schedule-badge--danger">Отменено</span>

                <span v-else-if="isTransferred" class="fitbase-schedule-badge fitbase-schedule-badge--warning">Перенесено</span>

                <span v-else-if="isPendingPayment" class="fitbase-schedule-badge fitbase-schedule-badge--neutral">
                    {{ event.status_label && event.status_label.text || 'Ожидает оплаты' }}
                </span>

                <template v-else-if="isSigned || isWaiting">
                    <span v-if="isSigned" class="fitbase-schedule-badge fitbase-schedule-badge--success">Вы записаны</span>
                    <span v-if="isWaiting" class="fitbase-schedule-badge fitbase-schedule-badge--neutral">Лист ожидания{{ event.records_waiting > 0 ? ' ' + event.records_waiting : '' }}</span>
                </template>

                <template v-else-if="event.need_register && !isOver">
                    <span v-if="isClosed && event.time_open" class="fitbase-schedule-badge fitbase-schedule-badge--neutral">Запись с {{ formatTimeOpen(event.time_open) }}</span>
                    <span v-else-if="isClosed" class="fitbase-schedule-badge fitbase-schedule-badge--neutral">Закрыто</span>
                    <span v-else-if="hasFreeSlots && event.hide_number_of_available_setting" class="fitbase-schedule-badge">Доступно</span>
                    <span v-else-if="hasFreeSlots && freeSlots === 1" class="fitbase-schedule-badge fitbase-schedule-badge--warning">1 место</span>
                    <span v-else-if="hasFreeSlots" class="fitbase-schedule-badge">
                        {{ event.records_limit > 0 ? freeSlots + ' ' + pluralMesta(freeSlots) : 'Доступно' }}
                    </span>
                    <span v-else class="fitbase-schedule-badge fitbase-schedule-badge--neutral">{{ event.status_label && event.status_label.text || 'Мест нет' }}</span>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'

export default {
    name: 'ScheduleEventCard',
    props: {
        event: { type: Object, required: true },
    },
    emits: ['click'],
    computed: {
        timeStart() {
            return moment(this.event.time_start, 'HH:mm:ss').format('HH:mm')
        },
        timeEnd() {
            if (!this.event.time_end || this.event.time_end === '00:00:00') return ''
            return moment(this.event.time_end, 'HH:mm:ss').format('HH:mm')
        },
        trainerName() {
            const t = this.event.trainer
            if (!t) return ''
            return [t.surname, t.name].filter(Boolean).join(' ')
        },
        trainerReplacementName() {
            const t = this.event.trainer_replacement
            if (!t) return ''
            return [t.surname, t.name].filter(Boolean).join(' ')
        },
        trainerPhoto() {
            const t = this.event.trainer_replacement || this.event.trainer
            return t ? (t.photo || null) : null
        },
        isCancelled() {
            return this.event.cancel === 1 || this.event.status === 'cancel'
        },
        isTransferred() {
            return this.event.status === 'transfer' || (this.event.transfer_event != null && !this.isSigned && !this.isWaiting)
        },
        isClosed() {
            return this.event.status === 'closed' || this.event.status === 'temporarily_closed'
        },
        isSigned() {
            return this.event.status === 'signed'
        },
        isPendingPayment() {
            return this.event.status === 'pending_payment'
        },
        isWaiting() {
            return this.event.status === 'waiting'
        },
        freeSlots() {
            if (!this.event.records_limit || this.event.records_limit === 0) return null
            return this.event.records_limit - (this.event.records_current || 0)
        },
        hasFreeSlots() {
            if (!this.event.records_limit || this.event.records_limit === 0) return true
            return this.freeSlots > 0
        },
        isOver() {
            if (!this.event.date || !this.event.time_start) return false
            const start = new Date(`${this.event.date}T${this.event.time_start}`)
            return Date.now() >= start.getTime()
        },
    },
    methods: {
        pluralMesta(n) {
            if (n === 1) return 'место'
            if (n >= 2 && n <= 4) return 'места'
            return 'мест'
        },
        formatTimeOpen(timeOpen) {
            if (!timeOpen) return ''
            const dt = new Date(timeOpen.replace(' ', 'T'))
            if (isNaN(dt.getTime())) return timeOpen
            const today = new Date()
            const isToday = dt.getFullYear() === today.getFullYear()
                && dt.getMonth() === today.getMonth()
                && dt.getDate() === today.getDate()
            if (isToday) {
                return String(dt.getHours()).padStart(2, '0') + ':' + String(dt.getMinutes()).padStart(2, '0')
            }
            return String(dt.getDate()).padStart(2, '0') + '.' + String(dt.getMonth() + 1).padStart(2, '0')
        },
    },
}
</script>
